import React from "react";
import { Box, Typography } from "@mui/material";
import { ClockifyTimeEntryTimeChangedAlert } from "../../features/alerts/clockifyTimeChangedAlert/ClockifyTimeEntryTimeChangedAlert";
import TimeFormatter from "../../features/extensions/TimeFormatter";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

interface ClockifyTimeChangedAlertProps {
  alert: ClockifyTimeEntryTimeChangedAlert;
}

const ClockifyTimeChangedAlert: React.FC<ClockifyTimeChangedAlertProps> = ({
  alert,
}) => {
  const timeFormatter = new TimeFormatter();
  const formattedDate = new Date(alert.dateCreated).toLocaleDateString();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        py: 0.5,
        whiteSpace: "nowrap",
        width: "max-content",
      }}
    >
      <AccessTimeIcon fontSize="small" color="action" />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          color: "text.primary",
          "& .time": {
            fontWeight: "medium",
            color: "primary.main",
          },
          "& .date": {
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            color: "text.secondary",
            ml: 0.5,
            borderLeft: "1px solid",
            borderColor: "divider",
            pl: 1,
          },
        }}
      >
        <Typography variant="body2" component="span">
          Time entry changed from
        </Typography>
        <Typography variant="body2" component="span" className="time">
          {timeFormatter.toHoursAndMinutes(alert.from)}
        </Typography>
        <Typography variant="body2" component="span">
          to
        </Typography>
        <Typography variant="body2" component="span" className="time">
          {timeFormatter.toHoursAndMinutes(alert.to)}
        </Typography>
        <Box component="span" className="date">
          <CalendarTodayIcon sx={{ fontSize: 14 }} />
          <Typography variant="body2" component="span">
            {formattedDate}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ClockifyTimeChangedAlert;
